'use client';

import { useEffect, useState } from 'react';

export const useGetDomElement = (
  selector: keyof HTMLElementTagNameMap
): HTMLElement | null => {
  const [element, setElement] = useState<HTMLElement | null>( null );

  useEffect( () => {
    const el = document.querySelector( selector );

    setElement( el );
  } );

  return element;
};
